import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faCaretDown, faCaretUp, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import TopIcon from "../../assets/images/card-top.svg"
import BottomIcon from "../../assets/images/card-bottom.svg"
import Refresh from "../../assets/images/Icon feather-refresh-ccw.svg"
import Pin from "../../assets/images/Icon metro-pin.svg"
import "./wallets.css"
import { Link, useNavigate } from "react-router-dom";
import { getBalanceOfToken } from "../../utils/web3";
import { connect } from 'react-redux';
import { ENV } from '../../config/config'

const WalletCard = (props) => {
    const { data, valueInUSD } = props
    const navigate = useNavigate()
    const { tokenWallets } = ENV.getUserKeys()
    const [tokenBalance, setTokenBalance] = useState()
    const [isActivee, setActivee] = useState(false);


    useEffect(() => {
        const fetchBalance = async () => {
            const balance = await getBalanceOfToken(data.networkId, data.walletAddress, tokenWallets.ethereum)
            setTokenBalance(balance)
        }
        fetchBalance()
            .catch(console.error);
    }, [])

    const toggleClass = () => {
        setActivee(!isActivee);
    };


    return (
        <div className="wallet-card position-relative main-wallet-cards">
            <div className="d-flex flex-column flex-sm-row">
                {/* <div className="bottom-icon" onClick={toggleClass}  >
                    <img style={{ cursor: "pointer" }} className="arrow-down" src={BottomIcon} alt="" />
                    <div className="arrow-up">
                        <div class="semicircle">
                            <FontAwesomeIcon className="text-white icon-up" icon={faChevronUp} />
                        </div>
                    </div>
                </div> */}
                <div className="d-flex flex-column flex-fill px-3">
                    <div className="card-body">
                        {/* <Link to={`/deposit/${data.symbol}`} className="side-tag">
                            <span className="d-inline-block align-top">More</span>
                        </Link> */}
                        {/* <div className="top-icon">
                            <img src={TopIcon} alt="" />
                        </div> */}
                        {/* <div className="bottom-icon d-none">
                        </div> */}
                        <div className="about flex-wrap d-flex">
                            <div className="me-2"><span className="pin-circle bg-white">
                                <img src={data.logo} alt="" />
                            </span></div>
                            <div>
                                <span className="d-block">{data.symbol}</span>
                                {/* <span className="value d-block">Interest {data.interestRate || 0}%</span> */}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between card-footer mb-4">
                            <div><span className="me-2">Wallet Balance</span></div>
                            <div>
                                {console.log(tokenBalance, "tokenBalancetokenBalancetokenBalancetokenBalance")}
                                <span className="me-2">{tokenBalance > 0  ? tokenBalance.toFixed(6) : 0} {data.symbol}</span>
                                {/* <FontAwesomeIcon className="text-white" icon={faCaretDown} /> */}
                            </div>
                        </div>
                        <div className="pin-details d-flex justify-content-center align-items-center flex-wrap ">
                            <div className="value-field">
                                <span>1 {data.symbol} = {valueInUSD} {ENV.defaultCurrency}</span>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="total-list flex-fill pe-3 ps-sm-0 ps-3 card-body">
                    {/* <div className="d-flex justify-content-between flex-wrap mb-3"> */}
                        {/* <span>Savings</span> */}
                        {/* <span className="me-2">{data.stakedAmount} {data.symbol}</span> */}
                    {/* </div> */}
                    <div className="d-flex justify-content-between about flex-wrap">
                        <div><button className="btn-triage-div btn-triage mb-3 mb-sm-0 me-2" onClick={() => { navigate(`/deposit/${data.symbol}`) }}><span>DEPOSIT</span></button></div>
                        <div> <button className="btn-triage-div btn-triage mb-3 mb-sm-0" onClick={() => { navigate(`/earn-interest/${data.symbol}`) }}><span>EARN INTEREST</span></button></div>
                    </div>

                    <div className="d-flex justify-content-between mb-4 card-footer">
                        <div><span className="me-2">Profit Balance</span></div>
                        <div>
                            <span className="me-2">{props.availableProfitStats > 0 ? (props.availableProfitStats).toFixed(6) :props.availableProfitStats } {data.symbol}</span>
                            {/* <FontAwesomeIcon className="text-white" icon={faCaretDown} /> */}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-3">
                        <div> <button className="btn-triage-div btn-triage" onClick={() => { navigate(`/withdrawal/${data.symbol}`) }}><span>WITHDRAW</span></button></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    user: state.user,
    dashboard: state.dashboard,

})

export default connect(mapStateToProps, {})(WalletCard)